import React from "react"
import PropTypes from "prop-types"

import styles from "./LinkWithArrow.module.sass"
import ArrowDown from "../../../widgets/TradeInValuations/icons/ArrowDown.svg?react"

const iconStyle = (direction) => {
  if (direction === "up") {
    return { transform: "rotate(180deg)" }
  } else if (direction === "left") {
    return { transform: "rotate(90deg)" }
  } else if (direction === "right") {
    return { transform: "rotate(-90deg)" }
  }

  return undefined
}

const LinkWithArrow = (props) => {
  return (
    <div
      tabIndex={0}
      role="button"
      aria-pressed={props.direction === "up"}
      className={styles.link}
      onClick={props.onClick}
      onKeyDown={(event) => {
        if (event.key === " " || event.key === "Enter") {
          props.onClick()
        }
      }}
    >
      {props.label}
      <ArrowDown fill={props.color} style={iconStyle(props.direction)} />
    </div>
  )
}

LinkWithArrow.propTypes = {
  label: PropTypes.string,
  direction: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default LinkWithArrow
